import { h } from "preact";
import { useEffect } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import AppLayout from "../components/AppLayout.jsx";
import WhitepaperErrorContent from "../components/WhitepaperErrorContent.jsx";
import i18n from "../i18n.js";
import { fetchWhitepapers, setLoading } from "../store";
import PostPreviewItem from "../components/PostPreviewItem.jsx";

export default function WhitepaperPage() {
  const dispatch = useDispatch();
  const whitepapers = useSelector((state) => state.whitepaper.items || []);
  const isErrornous = useSelector((state) => state.whitepaper.loadingError);
  const isLoading = useSelector((state) => state.whitepaper.loading);

  useEffect(() => {
    dispatch(fetchWhitepapers());
  }, []);

  useEffect(() => {
    dispatch(setLoading(isLoading));
  }, [isLoading]);

  if (isErrornous) {
    return (
      <AppLayout title={i18n.t("pages.titles.whitepaper")}>
        <WhitepaperErrorContent />
      </AppLayout>
    );
  }
  return (
    <AppLayout title={i18n.t("pages.titles.whitepaper")}>
      <div class="post-preview mt-48">
        {whitepapers.map((whitepaper) => (
          <PostPreviewItem whitepaper={whitepaper} />
        ))}
      </div>
    </AppLayout>
  );
}
